import { Component, OnInit } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'nz-modal-hung-up',
  templateUrl: './modal-hung-up.component.html',
  styleUrls: ['./modal-hung-up.component.scss']
})
export class NzModalHungUp implements OnInit {


  constructor(private modal: NzModalRef) { }

  ngOnInit(): void {

  }


  confirmModal() {
    this.modal.destroy({ data: true });
  }

}
